import React from 'react';
import { StyledCardBody } from './styled';

const CardBody: React.FC = ({ children, ...props }) => {
  return <StyledCardBody {...props}>{children}</StyledCardBody>;
};

export default CardBody;
